<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条计划执行信息</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="$router.go(-1)">返回上一级</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="执行计划编号" width="140">
        </el-table-column>
        <el-table-column label="资产名称" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.fixedAssetName }}
            </div>
            <div>
              {{ scope.row.fixedAssetNo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="资产卡号" align="center" min-width="200" prop="fixedAssetCards">
          <template slot-scope="scope">
            <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
              <div slot="content" class="">
                <div class="tooltip-text" v-for="item in scope.row.assetCardInfos" :key="item.id">
                  {{ item.no }}
                </div>
              </div>
              <span class="td-overflow-hidden">{{
                scope.row.assetCardInfos
                  ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                  : ""
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="specName" label="规格型号" width="100"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip label="品牌" align="center" min-width="100" prop="brandName" /> -->
        <el-table-column show-overflow-tooltip label="资产类型" align="center" min-width="130" prop="assetTypeName" />
        <el-table-column label="使用科室/库房" align="center" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.stockRange == 1">{{
              scope.row.stockDeptName
            }}</span>
            <span v-else>{{ scope.row.warehouseName }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="存放地点/货位" align="center" min-width="120" prop="locationName" />
        <el-table-column prop="planState" label="执行状态" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 0" style="color:#CCCCCC">
              <!-- 已忽略 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 1" style="color:#E8873D">
              <!-- 待执行 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 2" style="color:#6EA204">
              <!-- 执行中 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 3" style="color:#CE1126">
              <!-- 已过期 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 4" style="color:#6EA204">
              <!-- 已完成 -->
              {{ scope.row.stateName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button v-if="CanDo(scope.row) && tableAcl.indexOf('Edit') != -1" :disabled="scope.row.state != 1" type="text" v-preventReClick @click="handleUpdate(scope.row, 1)" :class="scope.row.state == 1 ? 'color-blue' : 'color-grey'">执行</el-button>
            <span v-else class="color-grey">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-button v-if="CanIgnore(scope.row) && tableAcl.indexOf('Edit') != -1" :disabled="scope.row.state != 1" type="text" v-preventReClick @click="handleUpdate(scope.row, 0)" class="margin-left20 " :class="scope.row.state == 1 ? 'color-blue' : 'color-grey'">忽略</el-button>
            <span v-else class="margin-left20 color-grey">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import {
  GetPatrolPlanExecuteDeatilss,
  AcceptOrIgnorePatrolPlanExecute,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
export default {
  mixins: [GetDataMixin],
  components: {},
  /** 定义属性 */
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        parentId: 0,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      if (!this.form.parentId) {
        var query = this.$route.query;
        if (query.id) {
          this.query.parentId = query.id;
        }
      }
      GetPatrolPlanExecuteDeatilss(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    // 执行或忽略
    handleUpdate (row, isSuccess) {
      AcceptOrIgnorePatrolPlanExecute({
        id: row.id,
        acceptOrIgnore: isSuccess,
        executePlanId: row.parentId,
      }).then((res) => {
        this.$my_message(`操作成功！`, "success");
        this.getData();
      });
    },
    CanDo (row) {
      if (row.state != 4) {
        return this.isAdmin || this.userInfo.id == this.dutyUserId;
      } else {
        return false;
      }
    },
    CanIgnore (row) {
      if (row.state != 0) {
        return this.isAdmin || this.userInfo.id == this.dutyUserId;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () { },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
